import psPlatformClient from "../psPlatformClient";
import {getJsonSize, TimeIndex} from "../ps-models";
import {
  LineItemsStore, LineItemsStoreDto,
  LineItemsStorePersistence,
  LineItemStoreFilter,
  PersistenceQuery, QueryResult
} from "../ps-models/lineitems-store";
import {LineItemStoreLogs, LineItemStoreLogsDto} from "../ps-models/LineItemStoreLogs";

export function buildLineItemsStorePersistence() {
  return new RESTLineItemsStorePersistence();
}

// Cache size limit: 10MB in bytes
const CACHE_SIZE_LIMIT = 10 * 1024 * 1024;

let CACHE: Record<string, LineItemsStore> = {}

export function clearLineItemsStoreCache() {
  CACHE = {};
}

class RESTLineItemsStorePersistence implements LineItemsStorePersistence {
  createLineItemsStore(timeIndex: TimeIndex): LineItemsStore {
    return new LineItemsStore(timeIndex);
  }

  async loadLineItemsStore(collection: string, id: string, createNonExistentStore: boolean = true): Promise<LineItemsStore> {
    const result = await psPlatformClient<null, any>({method: 'get',
      url: `/line-items-store/${collection}/${id}?createNonExistentStore=${createNonExistentStore}`});
    return LineItemsStore.deserialize(result.data);
  }

  async persistLineItemsStore(collection: string, store: LineItemsStore): Promise<void> {
    await psPlatformClient<any, null>({method: 'post', url: `/line-items-store/${collection}`,
      data: store.serialize(),
      headers: {'Content-Type': 'application/json'}});
      clearLineItemsStoreCache();
  }

  async query(collection: string, query: PersistenceQuery, customCompanyId?: string): Promise<LineItemsStore> {
    let cacheKey = collection + `-` + JSON.stringify(query);
    if(CACHE[cacheKey]){
      return CACHE[cacheKey]
    }

    console.time('PROF query')
    let res = await psPlatformClient<{query: any}, {store: LineItemsStoreDto, logs: LineItemStoreLogsDto}>({
      method: 'post',
      url: `/line-items-store/${collection}/persistence/query`,
      data: {query: query.serialize(),
      ...(customCompanyId ? {companyId: customCompanyId}: {})
      },
      headers: {'Content-Type': 'application/json'}
    });
    console.timeEnd('PROF query')

    let store = LineItemsStore.deserialize({...res.data.store, logs: res.data.logs});
    const storeSize = getJsonSize(store);
    
    if(storeSize <= CACHE_SIZE_LIMIT){
      CACHE[cacheKey] = store;
    } else {
      console.warn(`Store size (${(storeSize / 1024 / 1024).toFixed(2)}MB) exceeds cache limit (10MB), skipping cache for key: ${cacheKey}`);
    }
    return store;
  }

  async deleteStore(collection: string, id: string): Promise<void> {
    await psPlatformClient<any, any>({method: 'delete', url: `/line-items-store/${collection}/${id}`});
    clearLineItemsStoreCache();
  }
}


